import styled from 'styled-components';

export const Label = styled.span`
  font-size: ${({ theme }) => theme.fonts.fontSizeMedium};

  @media (min-width: 870px) {
    font-size: ${({ theme }) => theme.fonts.fontSizeMediumOne};
  }
`;
